(() => {
  document.documentElement.classList.add('js');

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu
  const menu = document.getElementById('MobileMenu');
  document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    });
  });

  // Reveal on scroll
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = Number(btn.dataset.step);
        input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.product__main img');
    const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
    const count = gallery.querySelector('[data-gallery-count]');
    if (!main || !thumbs.length) return;
    let current = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    const show = (index) => {
      current = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[current];
      main.src = thumb.dataset.src;
      main.removeAttribute('srcset');
      thumbs.forEach((t) => t.setAttribute('aria-current', 'false'));
      thumb.setAttribute('aria-current', 'true');
      if (count) count.textContent = `${current + 1} / ${thumbs.length}`;
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
    // Swipe on touch screens
    let startX = null;
    const frame = gallery.querySelector('.product__main');
    frame.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    frame.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
    // Preload the rest so swiping feels instant
    thumbs.forEach((t) => { const img = new Image(); img.src = t.dataset.src; });
  });

  // Variant selection: map chosen options to a variant id
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const json = form.querySelector('[data-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    const priceEl = document.querySelector('[data-price]');
    form.addEventListener('change', () => {
      const chosen = [...form.querySelectorAll('.option-group')].map((g) => g.querySelector('input:checked')?.value);
      const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) return;
      idInput.value = match.id;
      submit.disabled = !match.available;
      submit.querySelector('span').textContent = match.available ? submit.dataset.addLabel : submit.dataset.soldLabel;
      if (priceEl) priceEl.textContent = match.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    });
  });

  // AJAX add to cart with toast; falls back to a normal form post without JS
  const toast = document.getElementById('CartToast');
  const counts = document.querySelectorAll('[data-cart-count]');
  let toastTimer;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action$="/cart/add"]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to box');
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      counts.forEach((c) => { c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
      if (toast) {
        toast.querySelector('[data-toast-text]').textContent = toast.dataset.added;
        toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
      }
    } catch (err) {
      if (toast) {
        toast.querySelector('[data-toast-text]').textContent = err.message;
        toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
      }
    } finally {
      if (btn) btn.disabled = false;
    }
  });
})();
